<template>
  <div class="page" id="contactDebtorList">
    <div class="page-content">
      <f7-searchbar class="search"
        cancel-link="Cancel"
        search-list="#contact-debtors-list"
        :placeholder="$t('requestToPay.srch_in_cntcts')">
      </f7-searchbar>
      <div class="webdatalist">
        <f7-list id="contact-debtors-list" contacts>
          <f7-list-group v-for="(group, key) in this.contactSelectionList" :key="key">
            <f7-list-item :title="key" group-title></f7-list-item>
            <li v-for="contact in group" v-on:change="changeItem()" :disabled="isContactAvailable(contact)">
              <label class="item-radio item-content boxRequest">
                <input class="inputContact" type="radio" name="contactDebtorCheckbox"
                  :value="contact.id" v-model="contactDebtors">
                <i class="icon icon-radio"></i>
                <div class="item-inner">
                  <div class="item-title">{{contact.label}}</div>
                </div>
              </label>
            </li>
          </f7-list-group>
        </f7-list>
        <div class="row">
          <div class="col-md-3" :class="colorBottomButton">
            <f7-button round title="cancel" class="orangeConfirmationButton" @click="cancel">
              <f7-link> {{ $t('common.cncl')}}</f7-link>
            </f7-button>
          </div>
          <!-- We don't need this because we select only one -->
          <!-- <div class="col-md-3 offset-md-3">
            <f7-button round title="Add" class="orangeConfirmationButton" @click="goBack">
              <f7-link> {{ servicesTexts[this.$engine.user.currentService.id].add }}</f7-link>
            </f7-button>
          </div> -->
        </div>
      </div>
      <div class="row">
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import Service from '@/helpers/services.js'

export default {
  name: 'contactDebtorList',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  props: {
    service: {
      default: -1
    }
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      contactDebtors: '',
      contactSelectionList: [],
      currentRole: '',
      contactGroups: [],
      contactGroupsSelected: [],
      contactGroupsSelectedOld: []
    }
  },
  mounted () {
    let that = this
    that.contactDebtors = this.$engine.contacts.get()
    var contactList = {}
    for (var j = 0; j < this.$engine.contacts.get().length; j++) {
      var firstLetter = this.$engine.contacts.get(j).label.substr(0, 1).toUpperCase()
      if (!contactList.hasOwnProperty(firstLetter)) {
        contactList[firstLetter] = []
      }
      contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
      contactList[firstLetter].sort()
    }
    this.contactSelectionList = this.orderKeys(contactList)
    this.currentRole = 'simple'
    // TODO
    that.contactGroups = this.$engine.contacts.getContactGroup()
    this.contactGroupsSelected = this.$engine.services.payments.contactGroupsSelected
    this.contactGroupsSelectedOld = this.$engine.services.payments.contactGroupsSelected
  },
  created () {
    this.servicesTexts = {
      '1': { // request to pay
        title: this.$t('requestToPay.cntcts_lst'),
        search_in: this.$t('requestToPay.srch_in_cntcts')
      },
      '2': { // direct debit
        title: this.$t('modularLoan.dbtrs_lst'),
        search_in: this.$t('modularLoan.srch_in_dbtrs')
      },
      '6': { // direct payment
        title: this.$t('directPayments.bnfcrs_lst'),
        search_in: this.$t('directPayments.srch_in_bnfcrs')
      },
      '7': { // business document
        title: this.$t('businessDocuments.cntcts_lst'),
        search_in: this.$t('businessDocuments.srch_in_cntcts')
      }
    }
  },
  methods: {
    // removeDebtor (key) {
    //   this.$engine.services.payments.debtorList.splice(key, 1)
    // },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeItem () {
      let that = this
      that.contactDebtors = this.contactDebtors
      this.$engine.contacts.set(that.contactDebtors)
      this.goBack()
    },
    isContactAvailable (contact) {
      if ((this.service === Service.PAYMENTS && this.$engine.rights.rightIs('rtp_request_other_euro', false)) ||
          (this.service === Service.DIRECTDEBIT && this.$engine.rights.rightIs('ml_request_other_euro', false)) ||
          (this.service === Service.DIRECTPAYMENTS && this.$engine.rights.rightIs('dp_request_other_euro', false))) {
        if (this.$engine.contacts.getContactById(contact.id).zoneCode !== 'EUR') {
          return true
        }
      }
      return false
    },
    goBack () {
      this.$bus.emit('refresh-debtor-contact-list', this.contactDebtors)
      this.$f7.mainView.router.back()
    },
    cancel () {
      this.$f7.mainView.router.back()
    }
  }
}
</script>

<style scoped>
@media (min-width: 993px) {
  .search {
    margin-top: 80px;
  }
}
@media (max-width: 992px) {
  .search {
    margin-top: 44px;
  }
}
</style>
